<template>
  <p class="results-empty" :data-testid="TestId.finder.noResultsMessage">
    <template v-for="(part, index) in parts" :key="index">
      <template v-if="index === 1">{{ " " }}</template>
      <sp-button
        v-if="part.type === 'link'"
        class="results-empty__link"
        variant="appearance-link"
        @click="handleRemoveFilter(part)"
        >{{ part.label }}</sp-button
      >
      <FinderRichText v-else :html="part.text" />
    </template>
  </p>
</template>

<script setup>
import { TestId } from "#/test-ids";
import FinderRichText from "#ce/components/SpFinder/components/FinderRichText.ce.vue";

defineProps({
  /**
   * The message as parts: `{ type: "text", text }` for copy and `{ type: "link", label, filters }` for the
   * link that widens the search.
   *
   * @type {Array}
   */
  parts: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["add-filters"]);

function handleRemoveFilter(part) {
  emit("add-filters", part.filters);
}
</script>

<style lang="scss" scoped>
.results-empty {
  --text-color: var(--sp-comp-finder-results-empty-color, var(--sp-ref-palette-primary));
  --padding-block: var(--sp-comp-finder-results-empty-padding-block, var(--sp-ref-scale-40));
  --strong-font-size: var(--sp-comp-finder-results-empty-strong-font-size, var(--sp-ref-font-size-x-large));
  --link-text-decoration: var(--sp-comp-finder-results-empty-link-text-decoration, underline);

  margin: 0;
  padding-block: var(--padding-block);
  color: var(--text-color);
  text-align: center;

  :deep(strong) {
    font-size: var(--strong-font-size);
    font-weight: var(--sp-sys-font-weight-bold);
  }

  :deep(a) {
    color: inherit;
  }

  &__link {
    --sp-comp-button-appearance-link-text-color: currentColor;
    --sp-comp-button-appearance-link-text-decoration: var(--link-text-decoration);
    --sp-comp-button-font-weight: inherit;
    --sp-comp-button-display: inline;
  }
}
</style>
